import { render } from "./RatingView.vue?vue&type=template&id=b57deede&scoped=true"
import script from "./RatingView.vue?vue&type=script&lang=js"
export * from "./RatingView.vue?vue&type=script&lang=js"

import "./RatingView.vue?vue&type=style&index=0&id=b57deede&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b57deede"]])

export default __exports__